module.exports = __webpack_public_path__ + "static-v-shop/1786392158156/img/brands-mobile.1fa49ba5.png";